document.addEventListener('DOMContentLoaded', function() {
    /////preview
    let videoPreview = require('./modules/videoPreview');
    videoPreview();
////////////мобильное меню
    let mobileMenu = require('./modules/mobileMenu');
    mobileMenu();
    ////////////формы и модалки
    let forms = require('./modules/forms');
    forms();
    let mainMenu = require('./modules/main-menu');
    mainMenu();

    let getSlider = require('./modules/slider');
    getSlider('purify','myCarousel-wrapper','purify-items-wrapper','purify-item');
    getSlider('advantages','myCarousel-wrapper','advantages-slider','advantages-slider__item');
    getSlider('trust','myCarousel-wrapper','trust-slider','slider-item');
    getSlider('purify','myCarousel-wrapper','purify-items-wrapper','purify-item');
    getSlider('FVU-Mini','details-carousel-wrapper','details-carousel','details-item');
    getSlider('FVU-1P','details-carousel-wrapper','details-carousel','details-item');
    getSlider('FVU-1P-Long','details-carousel-wrapper','details-carousel','details-item');
    getSlider('FVU-Orange-V','details-carousel-wrapper','details-carousel','details-item');
    getSlider('FVU-Orange-2K','details-carousel-wrapper','details-carousel','details-item');
    getSlider('SFU-Modul','details-carousel-wrapper','details-carousel','details-item');
    getSlider('also','myCarousel-wrapper','purify-items-wrapper','purify-item');
    getSlider('also1P','myCarousel-wrapper','purify-items-wrapper','purify-item');
    getSlider('also1P-long','myCarousel-wrapper','purify-items-wrapper','purify-item');
    getSlider('also-orange','myCarousel-wrapper','purify-items-wrapper','purify-item');
    getSlider('also-2k','myCarousel-wrapper','purify-items-wrapper','purify-item');
    getSlider('also-modul','myCarousel-wrapper','purify-items-wrapper','purify-item');

    /////закрытие попапа подробнее
    let detailsCloseBtns = document.querySelectorAll('.details-popup-close');
    console.log(detailsCloseBtns);
    detailsCloseBtns.forEach(btn=>{
        btn.addEventListener('click',function() {
            btn.closest('.details-popup').classList.remove('active');
            document.body.classList.remove('hidden');
        })
    })
    let detailsBtns = document.querySelectorAll('.details-modal-btn');
    detailsBtns.forEach(btn=>{
        if(btn.dataset.expand) {
            let modal = document.querySelector('.'+btn.dataset.expand);
            btn.addEventListener('click',function() {
                document.querySelectorAll('.details-popup').forEach(item=>{
                    item.classList.remove('active');
                    console.log(modal);
                })
                modal.classList.add('active');
                document.body.classList.add('hidden');
            })

        }
    })
    ///////////ответы на вопросы
    let calcQuestionItem = require('./modules/question-item');
    calcQuestionItem();
    let validation = require('./modules/validation');
    validation();


//////////маска
    let getMask = require('./modules/mask');
    getMask();
    document.addEventListener('keydown', function(event) {
        let overlay = document.querySelector('.overlay');
        let infomodals = document.querySelectorAll('.details-popup');
        if (event.key === "Escape" || event.key === "Esc")  {
            if(overlay.style.display !== 'none') {
                overlay.style.display = 'none';
                document.body.classList.remove('hidden');
            }
            else {
                infomodals.forEach(modal=>{
                    modal.classList.remove('active');
                    document.body.classList.remove('hidden');
                })
            }

        }
    } )
})